import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  title: () => i18n.t(i18nKeys.privacy_requestArchive_title),
  subTitle: () => i18n.t(i18nKeys.privacy_requestArchive_subtitle),
  personalInfoLabel: () => i18n.t(i18nKeys.privacy_requestArchive_personalInfoLabel),
  personalInfoText: () => i18n.t(i18nKeys.privacy_requestArchive_personalInfoText),
  orderInfoLabel: () => i18n.t(i18nKeys.privacy_requestArchive_OrderInfoLabel),
  orderInfoText: () => i18n.t(i18nKeys.privacy_requestArchive_OrderInfoText),
  supportHistoryLabel: () => i18n.t(i18nKeys.privacy_requestArchive_SupportHistoryLabel),
  supportHistoryText: () => i18n.t(i18nKeys.privacy_requestArchive_SupportHistoryText),
  button: () => i18n.t(i18nKeys.privacy_requestArchive_button),
}
